<div class="table-responsive">
  <table class="table align-items-center table-flush">
    <thead class="thead-light">
    <tr>
      <th scope="col">Task</th>
      <th scope="col">Status</th>
      <th scope="col"></th>
    </tr>
    </thead>

    <tbody class="list">
    <tr *ngFor="let application of tasks; index as i">
      <td>
        {{ application.name }}
      </td>
      <td>
        <span class="mr-4 text-wrap">
          <span class="status ">{{ application.status }}</span>
        </span>
      </td>

      <td>
        <div *ngIf="!this.isReadOnly">
          <button (click)="openPdfModal(newPdfModal,application)"
                          *ngIf="shouldShowReadAndAgreeButton(application)"
                          class="btn btn-primary btn-sm">
                    <i class="fa fa-signature"></i> Read and Agree to</button>

          <button (click)="openPdfModal(newPdfModal,application)"
                  *ngIf="shouldShowReadAndCoCAgreeButton(application)" class="btn btn-primary btn-sm">
            <i class="fa fa-signature"></i> Read and Agree to</button>
          <ng-container *ngTemplateOutlet="getButtonTemplate(application)"></ng-container>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<!-- modal section -->
<ng-template #viewUserSignDocument>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Agreement</h4>
    <button (click)="formModal.hide()" aria-label="Close" class="close pull-right" type="button">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="agreement-container">
      <h2>Group Agreements</h2><br>
      for workshops and meetings<br>
      <a href="javascript:void(0)">to aim for</a><br>
      <a href="javascript:void(0)">Creating a group agreement</a><br>
      <a href="javascript:void(0)">If you don’t have time for this process...</a><br>
      <br>
      Group agreements can be a useful tool for making your event or meeting a good experience for everyone involved.
      The idea is for members of a group to create their own ground-rules for how to work together effectively and
      respectfully.
      <br>
      <br>
      <h3>Benefits</h3><br>
      One benefit of group agreements is that everyone gets the chance to express their own needs around what will
      enable them to participate fully and feel as safe as possible. We may assume everyone wants the same as us, but
      the reality is that everyone’s needs are different, and we don’t know what they are until we ask! Starting with an
      open conversation about how to meet the different needs may give us the best chance of making the space work for
      everyone.
      <br><br>
      Creating ground-rules together also gives more power to the group, compared to a facilitator or chair imposing
      rules on everyone else. People are then more likely to feel responsible for implementing the ground-rules.
      <br><br>
      <h3>Potential pitfalls</h3><br>
      However, a potential pitfall of group agreements is that the group members who feel most empowered to voice their
      needs may gain even more power by creating rules for everyone else to follow. This is a particular concern if the
      rules themselves could make it harder for people to challenge each other. For example, a guideline like 'Be polite
      even if you disagree' sounds inoffensive, but it could be a barrier to people voicing things if they are too angry
      to be polite! This in turn could discourage people from raising issues they feel strongly about, e.g. around
      oppressive behaviours or power dynamics.
      <br><br>
      <h3>What to aim for</h3><br>
      No agreement will be perfect for everyone. A useful yard stick is that a set of ground-rules is 'good enough' if
      it meets all the core needs, and as many preferences as possible. Needs are things people have to have in place in
      order to participate. Preferences are things we can be flexible about if they don't work for others. For example,
      someone might have a need for a venue with step-free access, and a preference for people using ‘hands up’ when
      they want to speak. In addition, try to be:
      <br><br>
      <h3>Concrete</h3><br>
      It needs to be clear how to implement the agreement. For example, if the rule says ‘respect confidentiality’ each
      person may have a different idea of what they can and can’t share. Encourage people to be specific, for example:
      “Don't share personal stories outside of this group”.
      <br><br>
      <h3>Realistic</h3><br>
      It needs to be possible for people to implement the agreement throughout the session. It is unlikely that anyone
      will completely transform the way they communicate simply because they have ‘agreed’ to a rule. Group agreements
      should also use language everyone is familiar with - for example, there's no point saying ‘express yourself in I
      statements’ unless everyone is already familiar with the concept!
      <br><br>
      <h3>Genuinely agreed</h3><br>
      In order to be empowering, a group agreement needs the genuine consent of everyone involved. Using the word
      ‘agreement’ would be unhelpful if some people didn't support it and didn't feel able to say.
      <br><br>
      For this reason, it is very important to go through a process that gives everyone time and space to really think
      about what their needs are and listen carefully to other people. Make sure to check at the end that people really
      do agree to stick to the suggested guidelines.
    </div>
  </div>
  <div class="modal-footer">
    <div class="footer-wraper">
      <div class="text-center mx-auto">
        <input [(ngModel)]="customerAcceptAgreement" class="mr-1" id="customCheckLogin" type="checkbox"/>
        <label for="customCheckLogin">
          <span>I have read and accept conditions</span>
          <a class="text-decoration-none checkbox-label ml-1" href="#" target="_blank">
            <strong>more detail</strong></a>
        </label>
      </div>
      <div class="text-center mx-auto">
        <button (click)="formModal.hide()" [disabled]="!customerAcceptAgreement" class="btn btn-primary" type="button">
          Sign Document
        </button>
        <button (click)="formModal.hide()" class="btn btn-secondary" type="button"> Cancel</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Scrollable New Modal -->
<ng-template #newPdfModal let-modal>
  <div class="modal-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <h4 class="modal-title">{{ selectedApplication.name }}</h4>
        </div>
        <div class="col-auto">
          <button (click)="pdfModalRef.hide()" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body scrollable-modal-body">
    <div class="container-fluid">
      <!-- PDF Viewer -->
      <div class="row">
        <div class="col-12">
          <ng-container *ngIf="selectedApplication">
            <pdf-viewer
              [render-text]="true"
              [src]="getPdfSrc(selectedApplication)"
              [zoom]="0.75"
            >
            </pdf-viewer>
          </ng-container>
          <div *ngIf="!getPdfSrc(selectedApplication)" class="text-center">
            <p>Loading PDF...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button (click)="performActionOnModalOk(selectedApplication)" class="btn btn-primary mr-2" type="button">Read and Agree
          </button>
          <button (click)="pdfModalRef.hide()" class="btn btn-secondary" type="button">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #downloadSignedDocumentTemplate>
  <button (click)="downloadPsa()" class="btn btn-outline-primary btn-sm btn-icon">
    <i class="fa fa-download"></i> Download Document
  </button>
</ng-template>

<ng-template #signDocumentTemplate>
  <button (click)="redirectToSignUrl()"  class="btn btn-primary btn-sm">
    <i class="fa fa-signature"></i> Sign
  </button>
</ng-template>
<ng-template #loadingTemplate>
  <span >Loading..
        </span>
</ng-template>
